import { App } from './app.class';
import sparkline from '@fnando/sparkline';
import Upgrademodal from './upgrademodal.class';
import { Notification } from './notification.class';
import { Modal } from './modal.class';

export class Page {

    constructor() {

        // Alle Sparkline initialisieren
        const $sparklines = document.querySelectorAll(".sparkline");
        function findClosest(target, tagName) {
            if (target.tagName === tagName) {
                return target;
            }
            while ((target = target.parentNode)) {
                if (target.tagName === tagName) {
                    break;
                }
            }
            return target;
        }
        $sparklines.forEach($sparkline => {

            // const data = [
            //     { name: "Jänner 2025", value: 45 },
            //     { name: "Februar 2025", value: 34 },
            //     { name: "März 2025", value: 67 },
            //     { name: "April 2025", value: 34 },
            //     { name: "Mai 2025", value: 56 },
            //     { name: "Juni 2025", value: 34 },
            //     { name: "Juli 2025", value: 56 },
            // ];

            let data = [];
            const str = $sparkline.dataset.sparkline;
            const parts = str.split(';');
            parts.forEach(p => {
                const elements = p.split(':');
                data.push({ name: elements[0], value: elements[1] });
            });

            sparkline($sparkline, data, {
                onmousemove(event, datapoint) {
                    const $svg = findClosest(event.target, "svg");
                    const $tooltip = $svg.nextElementSibling;

                    $tooltip.hidden = false;
                    $tooltip.textContent = `${datapoint.name}: ${datapoint.value}`;
                    $tooltip.style.top = `${event.offsetY}px`;
                    $tooltip.style.left = `${event.offsetX + 20}px`;
                  },
                onmouseout(event) {
                    const $svg = findClosest(event.target, "svg");
                    const $tooltip = $svg.nextElementSibling;
                    $tooltip.hidden = true;
                }
            });
        });

        // Klick auf Formular hinzufügen (Upgrade)
        const $btnAdd = document.querySelector("a.add");
        if($btnAdd) {
            $btnAdd.addEventListener('click', event => {

                // Upgrade nötig
                if($btnAdd.classList.contains("upgrade")) {
                    event.preventDefault();
                    const $ele = event.currentTarget;
                    const successMsg = $ele.dataset.successmsg ?? '';

                    Upgrademodal.open(
                        () => {

                            // Erfolgsmeldung
                            new Notification().success("Upgrade", successMsg);

                            // Upgrade-Klasse bei Button entfernen
                            $ele.classList.remove("upgrade");
                        },
                        "forms"
                    );
                }
            });
        }
    }
}

// Initialisierung wenn DOM geladen
App.domready(() => {
    if(document.querySelector('body').classList.contains('forms')) {
        new Page();
    }
});